import endPoint from '@/store/endPoint'
import { ERROR_CODES, API_ERROR_SUBTYPES } from '@/constants'

//Taken from ApplicationLoginOTP to also be usable in OAuth flow
export default {
  methods: {
    getApplicationAndStart() {
      let vm = this
      endPoint
        .getFormData(vm.$store.state.auth.idToken)
        .then(resp => {
          if (
            // If resuming and no pending applications found, let user
            // start a new application or enter a different email...

            resp.data.message ===
              'No pending applications found for this user' &&
            !vm.$store.state.isNewApplication
          ) {
            vm.$store.dispatch('setError', { type: ERROR_CODES.NO_PENDING })
            vm.$router.history.push('/error')
          } else if (
            // If no application returned & application in state
            !resp.data.body &&
            vm.$store.state.application
          ) {
            // First time user saves email needs to reset form or return user
            vm.$store
              .dispatch('createApplication')
              .then(() => {
                vm.$router.history.push('/application')
              })
              .catch(() => {
                vm.$store.dispatch('hideSpinner')
                this.$router.history.push('/error?type=500')
              })
          }  else {
            if (
              vm.$store.state.resumeViaEmail ||
              vm.$store.state.resumeViaButton
            ) {
              vm.$router.history.push('/application')
            } else {
              // Save it to application
              vm.$store.commit('set', [
                'application',
                resp.data.body.application
              ])
              vm.$router.history.push('/pendingApplications')
            }
          }
        })
        .catch(error => {
          vm.$store.dispatch('hideSpinner')
          vm.$store.dispatch('setAPIError', {
            error,
            fallbackCode: API_ERROR_SUBTYPES.getApplication
          })
          vm.$router.history.push('/error')
        })
    },
    getExistingApplication(cancelledApplicationClientName) {
      let vm = this

      if (
        vm.$store.state.isNewApplication ||
        vm.$store.state.resumeViaEmail 
      ) {
        vm.getApplicationAndStart()        
        vm.$store.commit('set', [
          'application.client.email',
          vm.$store.state.auth.userId
        ])        
      } else {
        vm.getApplicationAndStart()
            vm.$store.commit('set', [
              'application.client.email',
              vm.$store.state.auth.userId
            ])
      }
    }
  }
}
